import React from 'react';
import { AltSecondaryButton } from 'scy/buttons';
import PlusIcon from 'images/icons/controls/plus.svg?react-svg';
import margin from 'scy/margin.mod.scss';
import { width100 } from 'scy/utils.mod.scss';
import { secondaryButtonBackground } from 'components/checkoutPage/form/styles.mod.scss';

export default function AddNewButton({ onClick, text }) {
  return (
    <div className={secondaryButtonBackground}>
      <AltSecondaryButton noBorder className={width100} onClick={onClick}>
        <PlusIcon />
        <span className={margin.left_xs}>{text}</span>
      </AltSecondaryButton>
    </div>
  );
}
